module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NewsSearch"
  }, [_c('text-input', {
    ref: "input",
    staticClass: "NewsSearch-searchInput",
    class: {
      'NewsSearch-searchInput--isHidden': _vm.search.show
    },
    attrs: {
      "placeholder": "Search news",
      "large": ""
    },
    on: {
      "focus": _vm.focus,
      "submit": _vm.submit
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), _c('search-tray', {
    attrs: {
      "title": "News search",
      "results": _vm.results,
      "max-results": 50,
      "results-label": "posts",
      "anchor-right": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('news-search-result', {
          attrs: {
            "data": result
          }
        })]
      }
    }])
  }, [_c('text-input', {
    attrs: {
      "slot": "input",
      "placeholder": "Search news",
      "large": ""
    },
    on: {
      "submit": _vm.submit
    },
    slot: "input",
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44493fda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsSearch.vue
// module id = 761
// module chunks = 1474